import React from "react";
import "../CSS/styles.css";
import { Link } from 'react-router-dom';

const Development = () => {
  return (
    <div className="container inter mt-5">
      <div className="row pb-5">
        <Link to="/Projects" className="text-decoration-none">
          <div className="d-flex align-items-center px-lg-0 px-3">
            <div>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99756 13.648L3.33203 8.98242L7.99756 4.31689" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.6631 8.98242H3.33203" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div>
              <p className="ms-1 mb-0 fw-medium bc">Back to all Projects</p>
            </div>
          </div>
        </Link>
        <div className="col-lg-8 col-12 mt-5 px-lg-0 px-4">
          <h3 className="mb-0 bc fw-bold">Project Overview</h3>
          <p className="mb-0 mt-4 gc">Development and implementation of an integrated crisis response system for a multinational <br /> corporation  with operations in 15 countries, including crisis management protocols, <br /> communication systems, and training programs. </p>
          <h4 className="mb-0 fw-bold bc mt-5">Challenges</h4>
          <div className="d-flex flex-column mt-4">
            <div className="d-flex">
              <p className="mb-0 gc">•</p>
              <p className="mb-0 gc ms-2">Diverse operational environments across multiple countries</p>
            </div>
            <div className="d-flex mt-2">
              <p className="mb-0 gc">•</p>
              <p className="mb-0 gc ms-2">Complex organizational structure with varied crisis response needs</p>
            </div>
            <div className="d-flex mt-2">
              <p className="mb-0 gc">•</p>
              <p className="mb-0 gc ms-2">Integration with existing emergency response systems</p>
            </div>
            <div className="d-flex mt-2">
              <p className="mb-0 gc">•</p>
              <p className="mb-0 gc ms-2">Multi-language requirements for global implementation</p>
            </div>
          </div>
          <h4 className="mb-0 fw-bold bc mt-5">Our Approach</h4>
          <div className="d-flex flex-column mt-4">
            <div className="d-flex">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Conducted comprehensive risk assessment across all locations</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Developed customized crisis management framework and protocols</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Implemented secure crisis communication platform</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Created role-specific response procedures and checklists</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Delivered multi-tier crisis management training program</p>
            </div>
              <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Conducted simulation exercises to test system effectiveness</p>
            </div>
          </div>
          <h4 className="mb-0 fw-bold bc mt-5">Results</h4>
          <div className="d-flex flex-column mt-4">
            <div className="d-flex">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Established unified crisis response capability across global operations</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Reduced average crisis response time by 65%</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Successfully managed three significant incidents with minimal impact</p>
            </div>
            <div className="d-flex mt-2">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6663 5.85156L7.49967 15.0182L3.33301 10.8516" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <p className="mb-0 gc ms-2">Enhanced organizational resilience and business continuity</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-12 mt-lg-0 mt-5">
          <div className="vbg p-4 bor int2">
            <h5 className="mb-0 bc fw-semibold">Project Details</h5>
            <div className="d-flex align-items-center mt-3">
              <div>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_54_11699)">
                    <path d="M15.9684 2.64709H5.96842C5.04795 2.64709 4.30176 3.39329 4.30176 4.31376V17.6471C4.30176 18.5676 5.04795 19.3138 5.96842 19.3138H15.9684C16.8889 19.3138 17.6351 18.5676 17.6351 17.6471V4.31376C17.6351 3.39329 16.8889 2.64709 15.9684 2.64709Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8.46875 19.3138V15.9805H13.4687V19.3138" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.63574 5.98047H7.64408" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.3018 5.98047H14.3101" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.9688 5.98047H10.9771" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.9688 9.31384H10.9771" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.9688 12.6471H10.9771" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.3018 9.31384H14.3101" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.3018 12.6471H14.3101" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.63574 9.31384H7.64408" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.63574 12.6471H7.64408" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_54_11699">
                      <rect width="20" height="20" fill="white" transform="translate(0.96875 0.980469)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="ms-3">
                <p className="mb-0 fs-6-5 gc2">Client</p>
                <p className="mb-0 mt-0 gc">Global Manufacturing Corporation</p>
              </div>
            </div>
            <div className="d-flex align-items-center mt-3">
              <div>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_54_11717)">
                    <path d="M11.4574 3.1159C11.1449 2.80331 10.7211 2.62766 10.2791 2.62756H4.30241C3.86038 2.62756 3.43646 2.80316 3.1239 3.11572C2.81134 3.42828 2.63574 3.8522 2.63574 4.29423V10.2709C2.63584 10.7129 2.81149 11.1367 3.12408 11.4492L10.3774 18.7026C10.7562 19.0789 11.2684 19.2902 11.8024 19.2902C12.3364 19.2902 12.8486 19.0789 13.2274 18.7026L18.7107 13.2192C19.0871 12.8405 19.2984 12.3282 19.2984 11.7942C19.2984 11.2603 19.0871 10.748 18.7107 10.3692L11.4574 3.1159Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.21842 7.62764C7.44854 7.62764 7.63509 7.4411 7.63509 7.21098C7.63509 6.98086 7.44854 6.79431 7.21842 6.79431C6.98831 6.79431 6.80176 6.98086 6.80176 7.21098C6.80176 7.4411 6.98831 7.62764 7.21842 7.62764Z" fill="black" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_54_11717">
                      <rect width="20" height="20" fill="white" transform="translate(0.96875 0.960938)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="ms-3">
                <p className="mb-0 fs-6-5 gc2">Sector</p>
                <p className="mb-0 mt-0 gc">Manufacturing</p>
              </div>
            </div>
            <div className="d-flex align-items-center mt-3">
              <div>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_54_11726)">
                    <path d="M7.63574 2.60803V5.94137" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.3018 2.60803V5.94137" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M16.8021 4.27478H5.13542C4.21494 4.27478 3.46875 5.02097 3.46875 5.94145V17.6081C3.46875 18.5286 4.21494 19.2748 5.13542 19.2748H16.8021C17.7226 19.2748 18.4688 18.5286 18.4688 17.6081V5.94145C18.4688 5.02097 17.7226 4.27478 16.8021 4.27478Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.46875 9.27478H18.4687" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_54_11726">
                      <rect width="20" height="20" fill="white" transform="translate(0.96875 0.941406)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="ms-3">
                <p className="mb-0 fs-6-5 gc2">Duration</p>
                <p className="mb-0 mt-0 gc">6 months</p>
              </div>
            </div>
            <div className="d-flex align-items-center mt-3">
              <div>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_54_11737)">
                    <path d="M11.4574 3.07683C11.1449 2.76425 10.7211 2.5886 10.2791 2.5885H4.30241C3.86038 2.5885 3.43646 2.7641 3.1239 3.07666C2.81134 3.38922 2.63574 3.81314 2.63574 4.25517V10.2318C2.63584 10.6738 2.81149 11.0977 3.12408 11.4102L10.3774 18.6635C10.7562 19.0399 11.2684 19.2511 11.8024 19.2511C12.3364 19.2511 12.8486 19.0399 13.2274 18.6635L18.7107 13.1802C19.0871 12.8014 19.2984 12.2891 19.2984 11.7552C19.2984 11.2212 19.0871 10.7089 18.7107 10.3302L11.4574 3.07683Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.21842 7.58858C7.44854 7.58858 7.63509 7.40203 7.63509 7.17192C7.63509 6.9418 7.44854 6.75525 7.21842 6.75525C6.98831 6.75525 6.80176 6.9418 6.80176 7.17192C6.80176 7.40203 6.98831 7.58858 7.21842 7.58858Z" fill="black" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_54_11737">
                      <rect width="20" height="20" fill="white" transform="translate(0.96875 0.921875)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="ms-3">
                <p className="mb-0 fs-6-5 gc2">Category</p>
                <p className="mb-0 mt-0 gc">Crisis Management</p>
              </div>
            </div>
          </div>
          <div className="p-4 bor2 mt-5">
            <div>
              <h5 className="mb-0 bc fw-semibold">Client Testimonial</h5>
              <p className="mt-3 mb-0 gc">"TAMBRO delivered a crisis response system that perfectly addresses our complex global operations. The training and simulation exercises were particularly valuable in preparing our teams for real-world  incidents."</p>
              <div className="d-flex align-items-center mt-3">
                <div>
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.0524 17.5234V15.8568C16.0524 14.9727 15.7012 14.1249 15.0761 13.4997C14.451 12.8746 13.6031 12.5234 12.7191 12.5234H7.71908C6.83502 12.5234 5.98717 12.8746 5.36205 13.4997C4.73693 14.1249 4.38574 14.9727 4.38574 15.8568V17.5234" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.2191 9.1901C12.06 9.1901 13.5524 7.69772 13.5524 5.85677C13.5524 4.01582 12.06 2.52344 10.2191 2.52344C8.37813 2.52344 6.88574 4.01582 6.88574 5.85677C6.88574 7.69772 8.37813 9.1901 10.2191 9.1901Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className="ms-2">
                  <p className="mb-0 blc fw-medium">Chief Risk Officer</p>
                  <p className="mb-0 gc2 fs-6-5">Global Manufacturing Corporation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Development